// @flow
import React from 'react';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMUserResource from 'resources/SMUserResource';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMConst from 'lib/SMConst';
import SMTrackHelper from 'components/helpers/SMTrackHelper';

type Props = {
  delegate: Object,
  isOwner: boolean,
  reservation: Object,
  messageContent: string
};

type State = {
  reservation: Object,
  messageContent: string,
  errorMessage: string,
  attachedFilePath: string,
  attachedFileName: string

};

class SMMessageInputView extends React.Component {
  state: State

  constructor(props: Props) {
    super(props);
    this.state = {
      reservation: this.props.reservation,
      messageContent: this.props.messageContent || "",
      errorMessage: "",
      attachedFilePath: "",
      attachedFileName: ""
    };
  }

  onSubmit(e: SyntheticEvent){
    e.preventDefault();
    this.createMessage();
  }

  messageContentDidChange(){
    let message = this.refs.message.value;
    this.setState({
      messageContent: message
    });
    if(this.props.delegate && typeof this.props.delegate.messageContentDidChange === 'function'){
      this.props.delegate.messageContentDidChange(message);
    }
  }

  createMessage(){
    let reservation = this.props.reservation;
    let formData = new FormData(this.refs.form);
    let responseHandler = (data, error, xhr)=>{
      if (error) {
        if(this.props.delegate && typeof this.props.delegate.messageDidFailToCreate === 'function'){
          this.props.delegate.messageDidFailToCreate(error);
        }
        if (xhr.status != 403) {
          this.setState({
            errorMessage: xhr.responseJSON.message,
          });
        }
      }
      else {
        this.setState({
          messageContent: "",
          attachedFilePath: "",
          attachedFileName: ""
        });

        if(this.props.delegate && typeof this.props.delegate.messageDidCreate === 'function'){
          this.props.delegate.messageDidCreate(data);
        }
      }

    };

    if (this.props.isOwner) {
      SMOwnerResource.postMessage(reservation, formData, responseHandler);
    } else {
      SMUserResource.postMessage(reservation, formData, responseHandler);
    }
  }

  onFileSelect(e: SyntheticEvent){
    const target = e.target;
    if (target instanceof HTMLInputElement) {
      const files = target.files;
      let fileName = "";
      if (files.length > 0) {
        fileName = files[files.length - 1].name;
      }

      this.setState({
        attachedFilePath: target.value,
        attachedFileName: fileName
      });
      this.messageContentDidChange();
    }
  }

  trackPageEvent() {
    if (this.props.isOwner) {
      SMTrackHelper.pageEvent('od submit message');
    }
  }

  renderSubmitButton(){
    let reservation = this.props.reservation;

    if (!SMAppHelper.userIsDeleted(reservation.user) &&
      (this.state.messageContent.length > 0 || this.state.attachedFileName.length != 0 || !reservation.message_closed_at)) {
      return <input onClick={this.trackPageEvent.bind(this)} className="button-green pt10 pb10 w180 fr" type="submit" value="送信する" />;
    } else {
      return <input className="button-disabled pt10 pb10 w180 fr" disabled type="submit" value="送信する" />;
    }
  }

  render() {
    let reservation = this.props.reservation,
      imageURL, name;
    if (this.props.isOwner) {
      name = SMFormatHelper.ownerName(reservation.owner);
      imageURL = reservation.owner.profile_image;
    } else {
      name = SMFormatHelper.userNameWithReservation(reservation);
      imageURL = reservation.user.profile_image;
    }
    let errorRow = (this.state.errorMessage) ? <p style={{textAlign:"right"}} className="is-error mb15 mt10">{this.state.errorMessage}</p> : "";
    let disabled = (reservation.message_closed_at || SMAppHelper.userIsDeleted(reservation.user) || SMAppHelper.ownerIsDeleted(reservation.owner)) ? true : false;
    let placeholder = "";
    let divClassName = "dashboard-message-baloon__box__textarea dashboard-message-baloon__right__textarea";
    let spanClassName = "baloon__right__textarea-focus";
    let buttonClassName = "pt13 pb13 w180 mr10";

    if (disabled){
      let textareaDisabled = " textarea__disabled";
      if (reservation.message_disable_reason_type == SMConst.MessageDisableReasonType.Expired){
        placeholder = I18n.t("dashboard.label_000727");
      } else if (reservation.owner.deleted_at || reservation.user.deleted_at){
        placeholder = "";
      } else {
        placeholder = I18n.t("dashboard.label_000728");
      }
      divClassName += textareaDisabled;
      spanClassName += textareaDisabled;
      buttonClassName += " button-disabled";
    } else {
      placeholder = I18n.t("dashboard.label_000726");
      buttonClassName += " button-gray";
    }

    return (
      <div className="dashboard-message-box">
        <form ref="form" method="post" onSubmit={this.onSubmit.bind(this)}>
          <img src={imageURL} className="dashboard-message__icon fr" alt={name} />
          <div className={divClassName}>
            <textarea disabled={disabled}
              ref="message"
              name="content"
              value={this.state.messageContent}
              onChange={this.messageContentDidChange.bind(this)}
              className="dashboard-message-baloon__textarea" placeholder={placeholder}></textarea>
            <span className={spanClassName}></span>
          </div>
          {errorRow}
          <div className="dashboard-message__buttonarea">
            <input disabled={disabled} type="file" name="file" id="file" value={this.state.attachedFilePath} hidden onChange={this.onFileSelect.bind(this)} />
            <label htmlFor="file" className={buttonClassName}>
              <i className="fa fa-paperclip"></i> ファイルを選択
            </label>
            <span className="dashboard-form-file__name" ref="fileName">{this.state.attachedFileName}</span>
            {this.renderSubmitButton()}
          </div>
        </form>
      </div>
    );
  }
}

export default SMMessageInputView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMMessageInputView.jsx